import { render, staticRenderFns } from "./ViewMethodReviewPlan.vue?vue&type=template&id=0fba91ef&scoped=true"
import script from "./ViewMethodReviewPlan.vue?vue&type=script&lang=js"
export * from "./ViewMethodReviewPlan.vue?vue&type=script&lang=js"
import style0 from "./ViewMethodReviewPlan.vue?vue&type=style&index=0&id=0fba91ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba91ef",
  null
  
)

export default component.exports